import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import { BModal, BOverlay, BvModalEvent } from 'bootstrap-vue'

@Component({
  components: {
    BModal, BOverlay
  }
})
export default class WidgetDelete extends Vue {
  @Prop({ required: true }) value!: KwixeoDashboard.Widget|null

  private showModal = false
  private loading = false

  @Watch('value', { immediate: true })
  watchValue (value: KwixeoDashboard.Widget|null): void {
    this.showModal = value !== null
  }

  private get apiUrl (): string {
    return '/dashboard/' + this.value?.dashboard_id
  }

  private async onOk (event: BvModalEvent): Promise<void> {
    event.preventDefault()
    this.loading = true
    await this.$kwDashboard.axios.put(this.apiUrl, {
        remove_widgets: [this.value?.id]
      })
      .then(response => {
        this.$emit('deleted', response.data)
        this.onHidden()
      })
      .catch(error => {
        throw new Error(error)
      })
      .finally(() => {
        this.loading = false
      })
  }

  @Emit('hidden')
  private onHidden (): void {
    //
  }
}
